var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dots"},_vm._l((5),function(item){return _c('div',{key:item,staticClass:"d-inline-block"},[(item < _vm.number || item == _vm.number)?_c('div',{staticClass:"dot active"}):_c('div',{staticClass:"dot"})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }